import Step from 'components/global/Step'
import { FormattedMessage, useIntl } from 'react-intl'
import { Wrapper } from './style'
import Info from 'components/shared/Info'
import Box from 'components/shared/Box'
import SeparatedList from 'components/shared/SeparatedList'
import GuestForm from 'components/common/MarchPromo/components/GuestsForm/GuestsForm'
import { PRODUCT_ID_MARCH_VOUCHER_SELFCARE } from 'constants/app'
import { MARCH_PROMO_SELFCARE_VOUCHER_PRICE } from 'constants/prices'
import GuestsTotalPrice from 'components/common/MarchPromo/components/GuestsTotalPrice/GuestsTotalPrice'
import { useGuestsSelfcareCart } from 'components/common/MarchPromo/utils/useGuestsSelfcareCart'
import { useApp } from 'store/steps'
import SelfcareInfo from 'components/global/SelfcareInfo'
import { useResolutions } from 'store/resolutions'
import { useContext, useEffect } from 'react'
import Loader from 'components/shared/Loader'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'

const MarchPromoManageOrder = () => {
    const { formatMessage } = useIntl()
    const { navigateToStep } = useApp()
    const { isTablet } = useResolutions()
    const {
        cartItems,
        addItemsToCart,
        deleteItemsFromCart,
        isSubmitLoading,
        isDeleteLoading,
    } = useGuestsSelfcareCart()

    const { marchVouchersData } = useContext(GuestsDataContext)

    const handleContinue = async () => {
        // TODO: try to rewrite without then/catch, using rtk states
        addItemsToCart().then((response) => {
            const { isSuccess } = response

            if (isSuccess) {
                navigateToStep({ stepId: 'summary' })
            }
            // TODO: take care of errors
        })
    }

    useEffect(() => {
        if (cartItems.length !== 0) deleteItemsFromCart()
    }, [cartItems.length])

    return (
        <Step
            title={formatMessage({
                id: 'selfcare.march_promo.manage_header',
                defaultMessage: '_',
            })}
            onButtonClick={handleContinue}
            isButtonVisible
            isButtonLoading={isSubmitLoading}
            isButtonDisabled={
                isDeleteLoading ||
                cartItems.length !== 0 ||
                marchVouchersData.length === 0
            }
            withGoingBackDisabled
        >
            {isTablet && <SelfcareInfo />}

            <Wrapper>
                {cartItems.length !== 0 || marchVouchersData.length === 0 ? (
                    <Loader />
                ) : (
                    <SeparatedList
                        gap={24}
                        direction="column"
                        borderWidth={2}
                        isFullWidth
                    >
                        <GuestForm
                            voucherProductId={PRODUCT_ID_MARCH_VOUCHER_SELFCARE}
                            voucherPrice={MARCH_PROMO_SELFCARE_VOUCHER_PRICE}
                        />
                        <Box gap={24} isFullWidth>
                            <Box mt={[0, 8]} isFullWidth>
                                <Info color="info">
                                    <FormattedMessage
                                        id="selfcare.march_promo.upsells_info"
                                        defaultMessage="_"
                                    />
                                </Info>
                            </Box>
                            <GuestsTotalPrice />
                        </Box>
                    </SeparatedList>
                )}
            </Wrapper>
        </Step>
    )
}

export default MarchPromoManageOrder
